<template>
<!-- Main Content Area -->
<!-- HUGE COMMENT -->
        <!-- Please add autocomplete='off' to all input fields or at form level -->

<div class="deleteEmployeeVue">
      <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->


            <div class="row c-responsive-fixwidth">
                <div class="col-md-3">
                    <h1 class="h1">Employees</h1>
                </div>
                <div class="col-md-9 text-right">
                    <ul class="o-filter-area">


                    <li class="o-search-field">
                        <div class="input-group stylish-input-group">
                            <input autocomplete="off" type="text"  v-on:keyup="getAllEmployee()" v-model="search_query" class="form-control" placeholder="Search">
                            <!-- <span class="input-group-addon">
                            <button type="submit">
                            <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button> -->
                            </span>
                        </div>
                    </li>

                        <!-- <li><a @click="addEmployee()" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> Add new Employee</a></li> -->

                        <li><a href="javascript: void(0)" @click="deleteEmployers()" class="c-common-btn c-common-btn--inverse-icon-red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Employee</a></li>

                    </ul>

                </div>
            </div>



            <!-- /Heading Section -->
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">

                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding">
                        <form class="form-inline">
                            <div class="form-group">
                            <label for="exampleInputEmail3" class="common-label-text">Status Lavel</label>
                            <div class="o-cutsomSelect o-cutsomSelect--fixedwidth">
                                <select class="" @change="onChangeStatus()" v-model="selectedStatusId">
                                    
                                    <option v-for="status in statusList" :value="status.id">{{status.name}}</option>
                                    <option value="all">All</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail3" class="common-label-text">Short By</label>
                            <div class="o-cutsomSelect o-cutsomSelect--fixedwidth">
                                <select class="" @change="getAllEmployee()" v-model="selectedSortType">
                                    <option value="name">Name</option>
                                    <option value="seniority">Seniority </option>
                                    <option value="email">Email ID</option>
                                </select>
                            </div>
                        </div>
<!--                            <button type="submit" class="c-common-btn c-common-btn--green">Go</button>-->
                        </form>
                    </div>
                </div>
                <div class="c-common-space o-individual-calls">
                    <div class="col-sm-3 skillset o-no-padding">
                        <span class="common-label-text">Select:</span>
                        <button @click="selectAllEmployees()" type="submit" class="c-common-btn c-common-btn--small o-no-side-margin" :class="(selectedFilter == 'all')?'o-filter-active':''">All</button>
                        <button @click="selectNone()" type="submit" class="c-common-btn c-common-btn--small o-no-side-margin" :class="(selectedFilter == 'none')?'o-filter-active':''">None</button>
                    </div>
                </div>

                <div class="o-skills-listing">
                    <div v-loading="loading" class="row">
                        <div class="col col-sm-12">
                           <div class="o-scheduleTable--daily">
                                <div 
                                    infinite-scroll-disabled="busy" 
                                    infinite-scroll-distance="10" 
                                    class="extra-list-table-outer"
                                    v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                                    ref="scrollContainer"
                                    style="min-height: 1px;"
                                >
                                    <div v-for="(employee,index) in employees" :key="index" class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 delete-employees-list-table-align">
                                            <div class="calls-table-row">
                                                <div class="calls-table-cell">
                                                    <div class="checkbox o-custom-radio">
                                                        <label v-if="employeeId!=employee.employee_id">
                                                            <input type="checkbox" name="04" :value="employee.employee_id" v-model="selectedEmployeesId" @change="changeInput()">
                                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                            <div class="o-accordion-subtext user-icon o-emp-pic-align">
                                                                <div class="o-post-logged o-post-logged--table-user">
                                                                    <div class="o-user-profile-img o-header-profile-pic">
    <!--                                                                <img src="static/assets/images/user2.jpg">-->                                                                 <div v-if="employee.employable">               
                                                                        <img v-if="employee.employable && employee.employable.image != '' && employee.employable.image != 'NULL'" :src="(employee.employable.image)"  id='img-upload'/>
                                                                        <img v-if="employee.employable && employee.employable.image == '' || employee.employable.image == 'NULL'" src="static/assets/images/user1.png" id='img-upload' />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                <span>Name</span>
                                                                <div>{{(employee.employable)?employee.employable.first_name+" "+employee.employable.last_name:'--'}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                            <span class="">Schedule:</span>
                                                            <div class="notify-icon"><i class="fa fa-eye" aria-hidden="true"></i></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="calls-table-cell-inner-table">
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                <span>Sen:</span>
                                                                <div>{{employee.seniority}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Email ID:</span>
                                                            <div>{{employee.employable?employee.employable.email:'--'}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Phone:</span>
                                                            <div v-for="phone in (employee.employable ? employee.employable.phones : [])" v-if="phone.label=='Home phone' || phone.label=='home'">{{phone.phone_number}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Cell:</span>
                                                            <div v-for="phone in (employee.employable ? employee.employable.phones : [])" v-if="phone.label=='Cell phone' ||  phone.label=='mobile' ||  phone.label=='cell'">{{phone.phone_number}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                            <span class="">Notify</span>
                                                        <div class="notify-icon">
                                                        <a href="javascript: void(0)" @click="addBatchNotify(employee.employee_id)"><i class="fa fa-mobile" aria-hidden="true"></i></a>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="">
                                                        <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                            <span class="">Emergency</span>
                                                            <div class="notify-icon"><i class="fa fa-bullhorn" aria-hidden="true"></i></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                    <div v-if="employees.length == 0" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3">
                                        <div class="calls-table-row">
                                            <div class="calls-table-cell" style="height: 60px;">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <div>Empty Employee List</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <!-- /Main Body Content area -->
        
        <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
             <div class="modal-add-newJob" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center o-small-modal-head">
                            <button @click="closeBatchNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Notify</h4>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                            <div class="row">
                                <div class="col-sm-12">
                                  <ul class="o-modal-tab">
                                      <li v-if="getNotificationType=='email'"><a href="javascript: void(0)" @click="notifyEmailTab()" :class="(notifyTab == 'email')?'o-tab-active':''">Email</a></li>
                                      <li v-if="getNotificationType=='sms'"><a href="javascript: void(0)" @click="notifySmsTab()" :class="(notifyTab == 'sms')?'o-tab-active':''">SMS</a></li>
                                  </ul>     
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'email'">
                                  <div class="form-group o-attachment-sec">
                                   <vue-editor class="" v-model="emailContent"></vue-editor>   
<!--
                                   <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                            <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button> 
                                            <input type="file" name="myfile"> 
                                            <span>No file chosen</span>
                                        </div>
-->
                                    </div>    
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'sms'">
                                  <div class="o-sms-counter o-sms-counter-normal">{{smsContent.length}}/160</div>
                                   <textarea autocomplete="off" maxlength="160" v-model="smsContent" class="form-control o-no-radius notifySms-field" rows="10" placeholder="Type your SMS"></textarea>  
                                </div>
                            </div>
                        
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeBatchNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="sendNotify()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Send</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
       </modal>
       
</div>
<!-- /Main Content Area -->
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';
    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                getBaseURL: '',
                employees: [],
                savedEmployees: [],
                next_page: '',
                page_no: '',
                last_page: '',
                selectedEmployeesId: [],
                selectedFilter: 'none',
                selectedStatusId: 'all',
                statusList: [],
                selectedSortType: 'name',
                notifyTab: 'email',
                emailContent: '',
                smsContent: '',
                search_query:'',
                loading:'',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: 'userClientID',
                employeeId:'employeeId',
                getNotificationType: 'getNotificationType',

            }),
            // filterEmployee() {
            //     if (this.selectedStatusId == "all") {
            //         return this.employees;
            //     } else {
            //         //console.log(this.assignable_employees);
            //         let temp = [];

            //         temp = this.employees.filter((employee) => {
            //             if(employee.employee_status_id){
            //                 return employee.employee_status_id.match(this.selectedStatusId);
            //             }
            //         });
            //         //console.log(temp);
            //         return temp;
            //     }
            // }
        },

        methods: {
            changeInput(){
                if(this.employees.length==this.selectedEmployeesId.length){
                    this.selectedFilter = 'all';
                }else if(this.selectedEmployeesId.length==0){
                    this.selectedFilter = 'none';
                }else{
                    this.selectedFilter = '';
                }
                // console.log('test');
            }, 
            sendNotify() {
                let formData = {};
                if (this.notifyTab == 'email') {
                    formData = {
                        email: this.emailContent,
                        client_id: this.userClientID,
                        employee_ids: JSON.stringify(this.selectedEmpId)
                    };
                    //console.log(formData);
                } else {
                    formData = {
                        sms: this.smsContent,
                        client_id: this.userClientID,
                        employee_ids: JSON.stringify(this.selectedEmpId)
                    };
                    //console.log(formData);
                }

                service.post('employee/notifyEmployee', formData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Notify Successfully.',
                            type: 'success'
                        });
                        this.$modal.hide('batch-notify');
                    }).catch((err) => {
                        console.log(err);

                    });
            },
            notifyEmailTab() {
                this.notifyTab = 'email';
            },
            notifySmsTab() {
                this.notifyTab = 'sms';
            },
            addBatchNotify(employeeId) {
                this.selectedEmpId = [];
                this.selectedEmpId.push(employeeId);
                //console.log(employeeId);
                this.emailContent = "";
                this.smsContent = "";
                this.$modal.show('batch-notify');
            },
            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },
            // sortEmployee() {
            //     let self = this;
            //     //console.log(this.employees, this.selectedSortType);
            //     switch (this.selectedSortType) {
            //         case 'name':
            //             this.employees.sort(function(a, b) {
            //                 if (a.employable.first_name + " " + a.employable.last_name < b.employable.first_name + " " + b.employable.first_name) return -1;
            //                 if (a.employable.first_name + " " + a.employable.last_name > b.employable.first_name + " " + b.employable.first_name) return 1;
            //                 return 0;
            //             });
            //             //console.log('Short By Name');
            //             break;
            //         case 'sen':
            //             this.employees.sort(function(a, b) {
            //                 if (a.seniority < b.seniority) return -1;
            //                 if (a.seniority > b.seniority) return 1;
            //                 return 0;
            //             });
            //             break;
            //         case 'email':
            //             this.employees.sort(function(a, b) {
            //                 if (a.email < b.employable.email) return -1;
            //                 if (a.employable.email > b.employable.email) return 1;
            //                 return 0;
            //             });
            //             break;
            //         default:
            //             //console.log("default case..");
            //     }
            //     this.getAllEmployee();
            // },
            addEmployee() {
                this.$router.push({
                    'path': '/addEmployee'
                });
            },
            deleteEmployers() {
                if(this.selectedEmployeesId.length != 0){
                    this.$confirm('NAME will be removed from the records of CLIENT. Continue?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.loading=true;
                        service.post('employee/deleteBulk', {
                            'employee_ids': JSON.stringify(this.selectedEmployeesId),
                            'clientEmployee_id':this.employeeId,
                            'flag': this.selectedFilter,
                            'statusId': this.selectedStatusId,
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            this.$Progress.finish();
                            this.loading=false;
                            this.$message({
                                type: 'success',
                                message: 'Delete completed'
                            });
                            this.getAllEmployee();
                        }).catch((err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Delete canceled'
                        });
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: ' Please Select employees from list.'
                    });
                }
            },
            selectAllEmployees() {
                this.selectedFilter = 'all';
                let self = this;
                self.selectedEmployeesId=[];
                this.employees.forEach(function(employee) {
                    if(self.employeeId != employee.employee_id)
                        self.selectedEmployeesId.push(employee.employee_id);
                    else{
                        console.log(employee.employee_id);
                    }
                });
            },
            selectNone() {
                this.selectedFilter = 'none';
                this.selectedEmployeesId = [];
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                var arr = this.employees;
                if (this.savedEmployees.length != 0) {
                    this.savedEmployees.forEach(function(entry) {
                        arr.push(entry);
                    })
                    if(this.selectedFilter = 'all'){
                        this.selectAllEmployees();
                    }
                    this.savedEmployees=[];
                    if (this.next_page != null || this.next_page != "") {
                        await service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'employee-status-id': this.selectedStatusId,
                            'status': this.selectedStatusId,
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                            'pagination': true
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                } else
                    this.savedEmployees = [];

                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
            onChangeStatus() {
                this.getAllEmployee();
                //console.log('id', this.selectedStatusId);
            },
            getAllEmployee() {
                this.employees =[];
                this.loading=true;
                service.get('employee/getEmployeesByClient', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-status-id': this.selectedStatusId,
                    'status': this.selectedStatusId,
                    'sort': this.selectedShortType,
                    'search': this.search_query,
                    'pagination': true
                }).then((res) => {
                    this.employees = res.data.result.data;
                    //console.log('emp', this.employees);
                    //this.sortEmployee();
                    this.loading=false;
                    this.$Progress.finish();
                    this.last_page = res.data.result.total;
                    this.next_page = res.data.result.next_page_url;
                    //console.log("res", res.data.result.data[0].employable);
                    //console.log(this.employees);
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'employee-status-id': this.selectedStatusId,
                            'status': this.selectedStatusId,
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                            'pagination': true
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                });
            }
        },
        created() {
            this.getBaseURL = global[0].IMAGE_URL;
            this.$Progress.start();
            service.get('employee/employee_status_lite', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).
            then((res) => {
                this.statusList = res.data.result;
                //console.log('status', this.statusList);
                this.statusList.sort(function(a, b) {

                    if (Number(a.priority) < Number(b.priority)) return -1;
                    if (Number(a.priority) > Number(b.priority)) return 1;
                    return 0;
                });
                this.selectedStatusId=this.statusList[0].id;
                this.$Progress.finish();
                this.getAllEmployee();
            }).catch((err) => {
                console.log(err);
                this.$Progress.finish();
            });
            this.notifyTab=this.getNotificationType;
        }

    }

</script>
<style scoped>


</style>
